module.exports = __webpack_public_path__ + "img/1-1.79b69bc5.png";